import createCustomPropType from '../createCustomPropType';

// Valid String custom prop type
// this custom prop validator ensures that input components have
// clear, context-providing labels that accurately describe the input
// to the users. We use this to enforce that all inputs are properly labeled

// 2 is a magic number here chosen to represent the absolute minimum length of a string
const MIN_VALID_STRING_LENGTH = 2;

const makeInvalidStringMessage = (stringName, componentName) =>
  `${componentName} must have a prop \`${stringName}\` greater than ${MIN_VALID_STRING_LENGTH} characters.
This is enforced for accessibility concerns over the content being too short to provide enough context to the user.`;

const shouldThrowOnInvalidString = (stringValue, stringName, componentName) => {
  if (
    typeof stringValue === 'string' &&
    stringValue.trim().length < MIN_VALID_STRING_LENGTH
  ) {
    throw new Error(makeInvalidStringMessage(stringName, componentName));
  }
};

// Throws an error when an empty or short string is passed into a prop
// that expects a valid string such as an input label
const isValidString = (props, propName, componentName) => {
  shouldThrowOnInvalidString(props[propName], propName, componentName);
  if (typeof props[propName] !== 'string') {
    throw new Error(makeInvalidStringMessage(propName, componentName));
  }
};

export default createCustomPropType(isValidString);
